<template>
  <div>
    <v-card class="mx-auto my-4" max-width="550">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h1 class="text-h5 font-weight-bold mb-3">Contact us</h1>
            <p>
              Have a question that isn't covered in our
              <router-link to="/support">support page</router-link>? Send us
              a message below and we'll get back to you by email.
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0 mb-1">
            <v-text-field
              outlined
              name="contactName"
              v-model="name"
              label="Your name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0 mb-1">
            <v-text-field
              outlined
              name="contactEmail"
              v-model="email"
              label="Your email"
              :rules="[(v) => !!v || 'Email is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-textarea
              outlined
              name="contactMessage"
              v-model="message"
              label="Message"
              :rules="[(v) => !!v || 'Message is required']"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="errorMsg != ''">
          <v-col cols="12" class="pb-0 mb-2">
            <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              color="green darken-1"
              text
              @click="submit"
              :loading="loading"
            >
              Send
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" color="success" outlined>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMsg: "",
      loading: false,
      name: "",
      email: "",
      message: "",

      snackbar: false,
      snackbarText: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    this.email = this.$store.getters.getUser ? this.$store.getters.getUser : "";
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        this.errorMsg = "";
        if (this.email.trim() == "") {
          throw new Error("Email is required");
        }
        if (this.message.trim() == "") {
          throw new Error("Message is required");
        }
        await this.$utils.callBackendPost(this, "/pub/contactUs", {
          name: this.name,
          email: this.email,
          message: this.message,
        });
        this.message = "";
        this.snackbar = true;
        this.snackbarText = "Message sent - we'll get back to you soon";
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
